import { Card, Col, Row, Spin } from "antd";
import { Link, useHistory, useParams } from "react-router-dom";
import Text from "antd/lib/typography/Text";
import {
	cvAccessShareRequestConflict,
	cvAccessShareRequestFailedOther,
	cvAccessShareRequestForbidden,
	cvAccessShareRequestNotFound,
	cvAccessShareRequestSucceeded,
	selectLoading,
	selectMessage,
} from "./CVAccessSharingSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { theme } from "../../theme";
import CustomButton from "../../CustomComponents/CustomButton";
import Layout from "../../Containers/Layout";
import { shareCVAccess } from "../../Requests/polijobs-market-requests";
import { getErrorFromResponse } from "../../utils/responseUtils";
import { ErrorCodes } from "../../Api";
import { useEffect } from "react";
import { isUserLogged, useIsStudent } from "../../utils/utilFunctions";
import { Routes } from "../../utils/routes";

const CVAccessSharing = () => {
	const { t } = useTranslation();
	const { companyId } = useParams<{ companyId: string }>();
	const dispatch = useDispatch();
	const loading = useSelector(selectLoading);
	const message = useSelector(selectMessage);
	const history = useHistory();
	const isStudent = useIsStudent();

	useEffect(() => {
		if (!isUserLogged()) {
			localStorage.setItem("nextUrl", window.location.href);
			history.push("/autentificare");
		} else if (!isStudent) {
			history.push("/404");
		}
	}, [history]);

	useQuery(
		[shareCVAccess],
		() => {
			shareCVAccess(companyId)
				.then(() => {
					dispatch(cvAccessShareRequestSucceeded());
				})
				.catch(async (error) => {
					const errorMessage = await getErrorFromResponse(error);

					if (errorMessage?.code === ErrorCodes.CompanyNotFound) {
						dispatch(cvAccessShareRequestNotFound());
					} else if (errorMessage?.code === ErrorCodes.CvAccessAlreadyShared) {
						dispatch(cvAccessShareRequestConflict());
					} else if (errorMessage?.code === ErrorCodes.Forbidden) {
						dispatch(cvAccessShareRequestForbidden());
					} else {
						dispatch(cvAccessShareRequestFailedOther());
					}
				});
		},
		{
			refetchOnWindowFocus: false,
		}
	);

	return (
		<Layout>
			<div className="flex flex-col md:min-h-0 md:h-auto min-h-[100dvh] max-h-[100dvh] overflow-y-auto justify-center">
				<Card style={{ border: "none" }}>
					<Row justify="center" style={{ marginBottom: "1.5rem" }}>
						<Col
							xs={22}
							sm={18}
							md={12}
							lg={10}
							xl={8}
							style={{ textAlign: "center" }}
						>
							<img
								alt="logo"
								src="/images/logo/text.svg"
								style={{
									width: "100%",
									maxWidth: 300,
									height: "auto",
								}}
							/>
						</Col>
					</Row>

					<Row
						justify="center"
						style={{ marginBottom: "1.5rem", textAlign: "center" }}
					>
						<Col xs={22} sm={20} md={16}>
							{loading && <Spin size="large" style={{ marginBottom: 12 }} />}
							<Text
								style={{
									fontSize: "1.2rem",
									lineHeight: 1.4,
									wordWrap: "break-word",
								}}
							>
								{t(message)}
							</Text>
						</Col>
					</Row>

					<Row justify="center">
						<Col>
							<CustomButton
								backgroundcolor={theme.primaryColor}
								textcolor={theme.white}
								paddingvertical="1rem"
								style={{
									fontSize: "1rem",
									width: "fit-content",
									overflowWrap: "break-word",
								}}
							>
								<Link to={Routes.STUDENT_PROFILE}>
									{t("cvAccessShareText.redirect")}
								</Link>
							</CustomButton>
						</Col>
					</Row>
				</Card>
			</div>
		</Layout>
	);
};

export default CVAccessSharing;
